import React, { useEffect, useState } from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
// import logo from "../../assets/medal_pdf.png";
import logo from "../../assets/AI_Logo.png";

const styles = StyleSheet.create({
  titleContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row", // Aligns children (Image and Text) side by side
    alignItems: "center", // Vertically centers the Image and Text
    justifyContent: "space-between", // Places Image on left and Text on right
    padding: 0,
  },
  reportTitle: {
    textAlign: "right", // Aligns text to the right
    fontSize: 10, // Optional: Adjust font size for better fit
    flexShrink: 1,
    width: "40%",
    textAlign: "justify",
  },
  logo: {
    width: "180px",
    height: "56px",
    marginLeft: "5px",
    marginRight: "auto",
  },
});
const UniqueId = ({ certificateNo }) => {
  const [data, setData] = useState("");
  useEffect(() => {
    const uniquePartnerID =
      typeof window !== "undefined"
        ? localStorage.getItem("uniquePartnerID") || "N/A"
        : "N/A";
    setData(uniquePartnerID);
  }, []);
  return (
    <View style={styles.titleContainer}>
      <Image style={styles.logo} src={logo} />
      <View style={styles.reportTitle}>
        <Text>
          1407, B-Wing Parinee Crescenzo, G Block BKC, Mumbai, Maharashtra
          400051
        </Text>
        <Text>IRDAI License No. 744</Text>
        <Text>Unique Partner ID : {data}</Text>
      </View>
    </View>
  );
};

export default UniqueId;
